var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiClient } from "@/api/ApiClient";
import ProductCatalog from "@/components/products/ProductCatalog/ProductCatalog";
import "./CategoryProductsPage.css";
const CategoryProductsPage = () => {
    const { categorySlug } = useParams();
    const [categoryName, setCategoryName] = useState("");
    const [categoryId, setCategoryId] = useState("");
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchCategoryProducts = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            try {
                setLoading(true);
                const categories = yield apiClient.getAllCategories({
                    where: `slug(en-US="${categorySlug}")`,
                });
                if (categories.results.length > 0) {
                    const category = categories.results[0];
                    setCategoryName(((_a = category.name) === null || _a === void 0 ? void 0 : _a["en-US"]) || "");
                    setCategoryId(category.id);
                }
                setLoading(false);
            }
            catch (error) {
                console.error("Error fetching category:", error);
                setLoading(false);
            }
        });
        fetchCategoryProducts();
    }, [categorySlug]);
    if (loading) {
        return _jsx("div", { className: "loading-container", children: "Loading..." });
    }
    return (_jsxs("div", { className: "category-products-container", children: [_jsx("h1", { className: "category-title", children: categoryName }), _jsx(ProductCatalog, { categoryId: categoryId })] }));
};
export default CategoryProductsPage;
